const modulePages = [
	{
		id: 'm6-page-1',
		isFacilitatorOnly: false,
		title: 'VEND TANKELABYRINTER TIL BRUGBARE TANKER',
		facilitatorText: `Gå til www.basalsammen.dk. Skriv kode i elevlogin.
			<br /><br /><span><%GAMECODE%></span>`,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'm6-slide-1',
				type: 'image', 
				text: 'SLIDE 1',
				roles: ['facilitator']
			},
			{
				id: 'm6-slide-2',
				type: 'image', 
				text: 'SLIDE 2',
				roles: ['facilitator']
			},
		],
		minigames: [
			require('data/minigames/m6-change-negative-thoughts').minigameData
		]
	},
	{
		id: 'm6-page-2',
		isFacilitatorOnly: true,
		title: 'FØLELSESMEMORY',
		facilitatorText: null,
		icons: [],
		slides: [
			{
				id: 'm6-slide-3',
				type: 'image',
				text: 'SLIDE'
			},
			{
				id: 'm6-aktiv-ovelse',
				type: 'image',
				text: 'AKTIV ØVELSE'
			},
		]	
	},
	{
		id: 'm6-page-3',
		isFacilitatorOnly: false,
		title: 'KONFLIKTER',
		facilitatorText: `Gå til www.basalsammen.dk. Skriv kode i elevlogin.
			<br /><br /><span><%GAMECODE%></span>`,
		groupText: `Se, hvordan samtalen udvikler sig, afhængigt af de svar, I vælger.`,
		icons: [],
		slides: [
			{
				id: 'iderunde',
				type: 'image', 
				text: 'IDÉRUNDE',
				roles: ['facilitator']
			},
			{
				id: 'm6-basalboxen',
				type: 'image',
				text: 'BASALBOXEN',
				roles: ['facilitator']
			}
		],
		minigames: [
			require('data/minigames/m6-conflicts').minigameData
		]
	},
	{
		id: 'm6-page-4',
		isFacilitatorOnly: true,
		title: 'BASALPLAN',
		facilitatorText:null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'm6-case',
				type: 'image',
				text: 'CASE'
			},
			{
				id: 'm6-ovelse',
				type: 'image',
				text: 'ØVELSE'
			},
		]
	},
];


export {
	modulePages
};